module.exports = __webpack_public_path__ + "static/scale-model-of-the-florida-aquarium-in-tampa-florida-e2188de0a4d54161b9ecd390c2372b4d.png";